import {useGetCustomFormByName} from '../api';

export type UseCustomFormParams = {
	name: string;
};

export const useCustomForm = ({name}: UseCustomFormParams) => {
	const query = useGetCustomFormByName(
		{name},
		{
			retry: false,
			refetchOnWindowFocus: false,
		},
	);

	return {
		data: query.data,
		error: query.error,
		loading: query.isLoading || query.isFetching,
		name,
	};
};

export default useCustomForm;
